import actions from '../actions/versions';
import base from '../../../reducers/base';

const reducer = base(actions.types);
export default reducer;
